export const FEED_TYPES = {
  JSON: 'JSON',
  CSV: 'CSV',
  TXT: 'TXT',
  STIX: 'STIX',
};

export const FEED_AUTHORIZATION = {
  BASIC: 'BASIC',
  TOKEN: 'TOKEN',
  NOT_REQUIRED: null,
};

export const FEED_THREAT_TYPE = {
  IP: 'IP',
  DOMAIN: 'DOMAIN',
  URL: 'URL',
};

export const FEED_LABEL_OPTIONS = [
  { value: 'high', label: 'Trusted High' },
  { value: 'medium', label: 'General High Confidence' },
  { value: 'low', label: 'Lower Trust' },
];

export const FEED_IMPORTANCE_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];
